module.exports = __webpack_public_path__ + "img/colored-square.72a7f3ef.svg";